import MissionsPage from "./MissionsPage";

export default MissionsPage;
